import React, { useState } from "react";
import { CustomerForgotPassword } from "api/Auth";
import { toast } from "react-toastify";
import { useSetting } from "contexts/SettingContext";

export default function ForgotPasswordModal({ onClose }: { onClose: () => void }) {
    const { settings } = useSetting();
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!email.trim()) {
            toast.error("Vui lòng nhập email");
            return;
        }
        setLoading(true);
        try {
            const res = await CustomerForgotPassword(email, settings?.logo || '');
            if (res.status) {
                setSent(true);
                toast.success("Đã gửi email khôi phục mật khẩu. Vui lòng kiểm tra hộp thư.");
            } else if (res.error?.customer_not_exist) {
                toast.error("Email này không tồn tại. Vui lòng kiểm tra lại");
            } else {
                toast.error(res.msg || "Gửi yêu cầu thất bại");
            }
        } catch {
            toast.error("Có lỗi xảy ra, vui lòng thử lại");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            role="presentation"
            className="undefined styles_modalItem__YKbSY"
            aria-describedby="transition-modal-description"
            style={{
                position: "fixed",
                zIndex: 1300,
                inset: 0,
            }}
        >
            <div
                onClick={onClose}
                aria-hidden="true"
                style={{
                    zIndex: -1,
                    position: "fixed",
                    inset: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    WebkitTapHighlightColor: "transparent",
                }}
            />

            <div tabIndex={0} data-test="sentinelStart" />

            <div
                className="styles_auth_modal_content__gD2DP"
                tabIndex={-1}
                style={{ width: "30rem" }}
            >
                {/* HEADER */}
                <div className="MuiGrid-root styles_auth_modal_header__8MVV9 MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-content-xs-space-between">
                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-10">
                        <header className="styles_auth_modal_title__7Ht8G">
                            Khôi phục mật khẩu
                        </header>
                    </div>

                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-1">
                        <button
                            className="MuiButtonBase-root MuiIconButton-root styles_auth_modal_close__CfXli"
                            type="button"
                            aria-label="close"
                            onClick={onClose}
                        >
                            <span className="MuiIconButton-label">
                                <svg
                                    className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
                                    focusable="false"
                                    viewBox="0 0 24 24"
                                    aria-hidden="true"
                                >
                                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" />
                                </svg>
                            </span>
                            <span className="MuiTouchRipple-root" />
                        </button>
                    </div>
                </div>

                {/* BODY */}
                <div className="styles_auth_modal_body__le_XM">
                    <div>
                        <div>
                            {sent ? (
                                <div style={{ textAlign: "center", padding: "1.5rem 0.5rem" }}>
                                    <div style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}>
                                        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" style={{ color: "#428c04" }}>
                                            <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="currentColor"/>
                                        </svg>
                                    </div>
                                    <div style={{ fontSize: 15, color: "#333", lineHeight: 1.6, marginBottom: 20 }}>
                                        Đã gửi email khôi phục mật khẩu đến<br />
                                        <strong style={{ color: "#428c04" }}>{email}</strong>
                                    </div>
                                    <div style={{ fontSize: 13, color: "#888", marginBottom: 24 }}>
                                        Vui lòng kiểm tra hộp thư (bao gồm thư mục spam).<br />
                                        Nhấn vào liên kết trong email để đặt mật khẩu mới.
                                    </div>
                                    <div className="styles_center__ijy9t">
                                        <button
                                            className="MuiButtonBase-root MuiButton-root MuiButton-text sc-2362e412-0 iQEreR styles_btn__7hepk"
                                            type="button"
                                            onClick={onClose}
                                        >
                                            <span className="MuiButton-label">Đã hiểu</span>
                                            <span className="MuiTouchRipple-root" />
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div style={{ display: "flex", justifyContent: "center", marginBottom: 8 }}>
                                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" style={{ color: "#428c04" }}>
                                            <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2z" fill="currentColor"/>
                                        </svg>
                                    </div>
                                    <div className="styles_desc__gww0i" style={{ textAlign: "center", marginBottom: 4, fontSize: 14, color: "#666" }}>
                                        Nhập email đã đăng ký để nhận liên kết đặt lại mật khẩu
                                    </div>

                                    <form onSubmit={handleSubmit}>
                                        <div className="MuiGrid-root styles_formGridFieldName___9PUk MuiGrid-item MuiGrid-grid-xs-12 w-full my-32px">
                                            <div className="MuiFormControl-root MuiFormControl-fullWidth">
                                                <div className="MuiInputBase-root MuiOutlinedInput-root sc-242007b2-0 cWOwtw styles_input__a0YjR MuiInputBase-formControl px-16px">
                                                    <input
                                                        name="email"
                                                        placeholder="Nhập địa chỉ email"
                                                        type="email"
                                                        value={email}
                                                        className="MuiInputBase-input MuiOutlinedInput-input"
                                                        onChange={(e) => setEmail(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="styles_center__ijy9t MuiBox-root css-0">
                                            <button
                                                className="MuiButtonBase-root MuiButton-root MuiButton-text sc-2362e412-0 iQEreR styles_btn__7hepk"
                                                type="submit"
                                                disabled={loading}
                                                style={loading ? { opacity: 0.7, cursor: "not-allowed" } : {}}
                                            >
                                                <span className="MuiButton-label">
                                                    {loading ? "Đang gửi..." : "Gửi yêu cầu khôi phục"}
                                                </span>
                                                <span className="MuiTouchRipple-root" />
                                            </button>
                                        </div>
                                    </form>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div tabIndex={0} data-test="sentinelEnd" />
        </div>
    );
}
